import { Typography } from "@mui/material";

const BreakdownPanel = () => <Typography sx={{ color: "text.secondary" }}>TODO: Breakdown settings.</Typography>;

export default BreakdownPanel;
